import {
    CupomEstabelecimentoFornecedorInicial,
    type CupomEstabelecimentoFornecedorModel,
} from "../models/cupomEstabelecimentoFornecedorModel"
import {
    CupomEstabelecimentoFornecedorActionsTypes,
    type CupomEstabelecimentoFornecedorActionModel,
} from "./cupomEstabelecimentoFornecedorActions"

export function cupomEstabelecimentoFornecedorReducer(
    state: CupomEstabelecimentoFornecedorModel,
    action: CupomEstabelecimentoFornecedorActionModel
): CupomEstabelecimentoFornecedorModel {
    switch (action.type) {
        case CupomEstabelecimentoFornecedorActionsTypes.CARREGAR: {
            return {
                cupons: action.payload,
                pendingDelete: [],
                _nextLocalId: action.payload.length + 1,
            }
        }

        case CupomEstabelecimentoFornecedorActionsTypes.ADICIONAR: {
            const novaId = state._nextLocalId
            return {
                ...state,
                _nextLocalId: novaId + 1,
                cupons: [
                    ...state.cupons,
                    {
                        localId: novaId,
                        id: null,
                        cupomId: null,
                        nomeCupom: "CUPOMSEMNOME",
                        valor: 10,
                        percentual: true,
                        quantidadePorCliente: 1,
                        quantidadeMaxima: 9999,
                        valorMinimoPedido: null,
                        maximoDesconto: null,
                        apenasPrimeiraCompra: true,
                        automatico: true,
                        ativo: true,
                        freteGratis: false,
                        appSiteTodos: 0,
                        validadeDias: 30,
                        fimCupomTimestamp: null,
                        visivelTelaInicial: false,
                        horarioAlmoco: false,
                        exigirFacebookParaDesconto: false,
                        exigirEnderecoUnicoParaDesconto: false,
                        exigirCpfParaDesconto: false,
                        telefoneCliente: null,
                        descricao: "",
                        olharListaClientes: false,
                        quantidadeUtilizada: 0,
                    },
                ],
            }
        }

        case CupomEstabelecimentoFornecedorActionsTypes.REMOVER: {
            const { localId, dbId } = action.payload
            const encontrou = state.cupons.some(c => c.localId === localId)
            if (!encontrou) return state
            return {
                ...state,
                cupons: state.cupons.filter(c => c.localId !== localId),
                pendingDelete:
                    dbId !== null && dbId > 0
                        ? [...state.pendingDelete, dbId]
                        : state.pendingDelete,
            }
        }

        case CupomEstabelecimentoFornecedorActionsTypes.ATUALIZAR_CAMPO: {
            const { localId, campo, valor } = action.payload
            return {
                ...state,
                cupons: state.cupons.map(c =>
                    c.localId === localId ? { ...c, [campo]: valor } : c
                ),
            }
        }

        case CupomEstabelecimentoFornecedorActionsTypes.CONFIRMAR_SAVE: {
            return {
                ...state,
                pendingDelete: [],
                cupons: state.cupons.map((c, i) => ({
                    ...c,
                    id: action.payload[i]?.id ?? c.id,
                    cupomId: action.payload[i]?.cupomId ?? c.cupomId,
                })),
            }
        }

        default:
            return state
    }
}

export { CupomEstabelecimentoFornecedorInicial }
